import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LimitsReminderConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getLimitsModalTimeout(): number {
		return this.configService.get((x) => x.common.limitsReminder?.limitsModalTimeout, 10000);
	}

	isLastLoginTimestampEnabled(): boolean {
		return this.configService.get((x) => x.common.limitsReminder?.isLastLoginTimestampEnabled, false);
	}
}
